import { Controller, useWatch } from '@eigtech/ui-shared-forms/shadcn'
import { Checkbox } from '@eigtech/ui/components/checkbox'
import { Label } from '@eigtech/ui/components/label'
import { Stack } from '@eigtech/ui/components/stack'
import { ReactNode } from 'react'
import {
  ContactForm,
  ContactFormArrayField,
  ContactFormInputField,
  useContactFormArrayFieldRowContext,
  useContactFormContext,
} from './ContactFormSchema/ContactFormSchema'
import { ContactInfoRowContainer } from './ContactInfoRowContainer'

export function EmailFieldArray() {
  return (
    <ContactFormArrayField
      RowContainer={RowContainer}
      defaultValue={{} as ContactForm['emails'][number]}
      name="emails"
      renderRow={EmailField}
    />
  )
}

function RowContainer(props: { children: ReactNode; index: number }) {
  const isDisabledOverride = useWatch({ name: `emails.${props.index}.isDisabled` })

  return (
    <ContactInfoRowContainer
      {...props}
      disabled={isDisabledOverride}
      indexKey="primaryEmailIndex"
    />
  )
}

export function EmailField() {
  const { control } = useContactFormContext()
  const { index } = useContactFormArrayFieldRowContext()

  const isDisabled = useWatch({ control, name: `emails.${index}.isDisabled` })

  return (
    <Stack className="w-full gap-3">
      <ContactFormInputField
        disabled={!!isDisabled}
        label="Email"
        name={`emails.${index}.email`}
        type="email"
      />

      <Controller
        control={control}
        name="primaryEmailIndex"
        render={({ field: { onChange: setPrimaryIndex, value: primaryIndex, ...props } }) => (
          <Label className="flex flex-row items-center gap-2">
            <Checkbox
              checked={primaryIndex === index}
              onCheckedChange={(checked) =>
                checked ? setPrimaryIndex(index) : setPrimaryIndex(null)
              }
              {...props}
            />
            Is Primary
          </Label>
        )}
      />
    </Stack>
  )
}
